import { ICourse, ICourse2 } from '@et/types/Courses'
import DefaultTheme from '@styles/themes/defaultTheme'
import { PAYMENT_TYPES_THEME } from '@et/types/Enums'
import { deepPurple, neonPink } from '@styles/themes/darkThemeBeautifulLettering'
import { graphql } from 'gatsby'
// TODO: reg price link and sale price link so we only have to change one item
const slug = 'messy-watercolors'
const title = 'Messy Watercolors in Procreate'
const highlight1 = `#B77DC3`
const mainColor = `#4D286F`
const course: ICourse2 = {
  theme: PAYMENT_TYPES_THEME.LIGHT,
  title,
  slug,
  videoId: `fczxov3row`,
  keywords: [
    'messy watercolors in procreate', 'ipad lettering', 'procreate', 'procreate tutorial', 'hand lettering', 'lettering', 'procreate lettering', 'procreate for beginners', 'procreate lettering tutorial', 'procreate app', 'ipad lettering procreate', 'iPad Pro', 'ipad lettering for beginners', 'calligraphy', 'lettering in procreate', 'how to hand letter', 'procreate brushes', 'procreate tips', 'ipad pro lettering', 'ipad lettering tutorial', 'procreate tutorial lettering'
  ],
  price: '247',
  salePrice: '197',
  paymentPlan:{
    price: '90',
    perMonth: '3 Payments of $90/m',
    savings: '10%'
  },
  motionMail: `https://s.mmgo.io/t/CTCn/scale_2x`,
  onSale: false,
  tagline: 'Learn how to digitally paint and print messy watercolor artwork in Procreate',
  classDescriptor: 'Learn how to digitally paint and print messy watercolor artwork in Procreate',
  intro: {
    imgName: 'procreate301/tablet-intro.png',
    imgAlt: 'Create custom modern lettering styles that are unique to you',
    bullets: [
      {
        title: 'Beginner Friendly',
        desc:
          'Step-by-step narration with closeups on all the details, so you feel confident in the process from start to finish.',
      },
      {
        title: 'A Versatile Process',
        desc:
          'Since every lettering style is different, this process has been fine-tuned to fit any situation. You’ll be able to achieve a realistic watercolor effect when you apply it to any style - hand lettered or typed.',
      },
      {
        title: 'Blend Options',
        desc:
          'You may want an ombré, one color, smooth transitions blend with one of your pieces and a multi-colored blend with water pockets on another. This course serves up 5 different blend options, so you’ll have plenty to choose from when you begin your next lettering piece.',
      },
      {
        title: 'Florals + Foliage Integration',
        desc:
          'Take your watercolor lettering even further by integrating florals and foliage! A bonus florals foundations module is included, so even if you’ve never painted florals before, you’ll be able to follow along and complete every project in the class.',
      },
    ],
  },
  projects: {
    beginner: [
      {
        title: 'Project 1',
        backgroundColor: `#c4d8da`,
        textColor: `#4a5457`,
        subheadColor: `#fff`,
        projectImg: `procreate301/project-1.jpg`,
        projectImgMobile: `procreate301/project-1.jpg`,
        type: '',
        desc:
          'We begin with a practice project, painting the same subject (leafy branch) in the 3 different types of messy watercolor (little mess to lots of mess). You’ll learn all the components needed and various methods introduced as the messiness becomes increasingly complex.',
      },
      {
        title: 'Project 2',
        backgroundColor: `#fcbfb2`,
        textColor: `#4a5457`,
        subheadColor: `#fcb900`,
        projectImg: `procreate301/project-2.jpg`,
        projectImgMobile: `procreate301/project-2-mobile.jpg`,
        type: '',
        desc:
          'We take what we went over in Project 1 and apply the mid level/extra messy aesthetic to a popsicle! We use an existing, traditional painting as a reference to guide us on what to look for when we transition to only having a photo reference.',
      },
      {
        title: 'Project 3',
        backgroundColor: `#ffe3df`,
        textColor: `#4a5457`,
        subheadColor: `#f3ecdf`,
        projectImg: `procreate301/project-3.jpg`,
        projectImgMobile: `procreate301/project-3-mobile.jpg`,
        type: '',
        desc: 'In our first project based on a photograph, we utilize techniques we established in the first two projects to interpret a photograph in the messy watercolor style. We focus on color and texture layering, how to avoid muddy colors and how to stack different blend modes for the most eye catching result.',
      },
      {
        title: 'Project 4',
        projectImg: `procreate501/project-4.jpg`,
        projectImgMobile: `procreate301/project-4-mobile.jpg`,
        backgroundColor: `#dee5dd`,
        textColor: `#565857`,
        subheadColor: `#c56b00`,
        type: '',
        desc:
          'In Project 4, we go over different ways to alter a reference photo’s color and we experiment with the level of mess we prefer, where to implement it and where our bleeds and blends will be the most impactful.',
      },
      {
        title: 'Project 5',
        projectImg: `procreate301/project-5.jpg`,
        projectImgMobile: `procreate301/project-5-mobile.jpg`,
        backgroundColor: `#ffd5bc`,
        textColor: `#4a5457`,
        subheadColor: `#419187`,
        type: '',
        desc:
          'In our first animal painting, we discuss where to keep extra details and where to apply our messiness based on the subject and the subject’s position. We layer on color and blend modes and place wet and dry textures with intention to captivate the viewer’s focus.',
      },
      {
        title: 'Project 6',
        projectImg: `procreate301/project-6.jpg`,
        projectImgMobile: `procreate301/project-6-mobile.jpg`,
        backgroundColor: `#a39691`,
        textColor: `#4a5457`,
        subheadColor: `#be8d87`,
        type: '',
        desc:
          'Our 6th project is all about simulating fur and allowing a viewer’s eye to move in the direction we choose. We pay close attention to small details in this project and see how subtle changes and choices can have dramatic effects on our final piece.',
      },
      {
        title: 'Project 7',
        projectImg: `procreate301/project-7.jpg`,
        projectImgMobile: `procreate301/project-7-mobile.jpg`,
        backgroundColor: `#95b7db`,
        textColor: `#4a5457`,
        subheadColor: `#f4d547`,
        type: '',
        desc:
          'We conclude our animal projects with the most complex of the course: a beta fish. We add hyper-realistic details and juxtapose them near extreme messiness and create a composition of dramatic, saturated color.',
      },
    ],
    advanced: [],
  },
  curriculum: [
    {
      title: 'Welcome',
      videos: [
        {
          title: 'Course Overview',
          duration: '9:11',
        },
        {
          title: 'Bonuses Location + Install Instructions',
          duration: '6:37',
        },
        {
          title: 'Brush Set Overview',
          duration: '8:22',
        }
      ],
    },
    {
      title: 'Best Practices for Setting up Files',
      videos: [
        {
          title: 'Canvas Size + Resolution',
          duration: '3:33',
        },
        {
          title: 'Color Profiles',
          duration: '3:41',
        },
        {
          title: 'Rights for Using Reference Images',
          duration: '3:08',
        },
      ],
    },
    {
      title: 'Influences + Inspiration',
      videos: [
        {
          title: 'Traditional Messy Watercolor Artists',
          duration: '4:06',
        },
      ],
    },
    {
      title: 'Project 1: Leafy Levels of Messy',
      videos: [
        {
          title: 'Replicating the Painting: Part 1',
          duration: '9:34',
        },
        {
          title: 'Replicating the Painting: Part 2',
          duration: '15:56',
        },
        {
          title: 'Little Loose, Little Messy',
          duration: '9:40',
        },
        {
          title: 'Loose + Messy',
          duration: '7:33',
        },
        {
          title: 'Extra Loose, Extra Messy',
          duration: '7:59',
        },
      ],
    },
    {
      title: 'Project 2: Messy Popsicle',
      videos: [
        {
          title: 'Setting up your File',
          duration: '3:34',
        },
        {
          title: 'Creating the Base Painting',
          duration: '7:48',
        },
        {
          title: 'Adding Texture + Enhancing Colors',
          duration: '11:12',
        },
        {
          title: 'Adding the Mess + Finishing Touches',
          duration: '10:46',
        },
      ],
    },
    {
      title: 'Project 3: Messy Watermelon',
      videos: [
        {
          title: 'Setting up your File',
          duration: '1:55',
        },
        {
          title: 'Base Painting',
          duration: '7:44',
        },
        {
          title: 'Adding Texture: Part 1',
          duration: '8:56',
        },
        {
          title: 'Adding Texture: Part 2',
          duration: '8:50',
        },
        {
          title: 'Adding the Mess + Finishing Touches',
          duration: '9:51',
        },
      ],
    },
    {
      title: 'Project 4: Messy Echinacea',
      videos: [
        {
          title: 'Setting up your File',
          duration: '3:55',
        },
        {
          title: 'Reference Photo Selective Recoloring Methods',
          duration: '8:43',
        },
        {
          title: 'Base Painting: Petals',
          duration: '12:44',
        },
        {
          title: 'Base Painting: Stamen + Stem',
          duration: '7:26',
        },
        {
          title: 'Painting Petal Details',
          duration: '7:13',
        },
        {
          title: 'Paint the Messy Stamen',
          duration: '5:46',
        },
        {
          title: 'Adding the Mess + Finishing Touches',
          duration: '8:04',
        },
      ],
    },
    {
      title: 'Project 5: Messy Bird',
      videos: [
        {
          title: 'Setting up your File',
          duration: '5:43',
        },
        {
          title: 'Base Painting: Part 1',
          duration: '7:57',
        },
        {
          title: 'Base Painting: Part 2',
          duration: '5:29',
        },
        {
          title: 'Painting a Realistic Eye + Beak',
          duration: '7:46',
        },
        {
          title: 'Detailing the Head',
          duration: '5:22',
        },
        {
          title: 'Adding Texture: Part 1',
          duration: '7:15',
        },
        {
          title: 'Adding Texture: Part 2',
          duration: '6:53',
        },
        {
          title: 'Messy Details',
          duration: '6:38',
        },
        {
          title: 'Finishing Touches',
          duration: '6:44',
        },
      ],
    },
    {
      title: 'Project 6: Messy Fox',
      videos: [
        {
          title: 'Setting up your File',
          duration: '5:17',
        },
        {
          title: 'Base Painting',
          duration: '9:39',
        },
        {
          title: 'Painting a Realistic Eye + Nose',
          duration: '5:05',
        },
        {
          title: 'Adding Texture: Part 1',
          duration: '7:59',
        },
        {
          title: 'Adding Texture: Part 2',
          duration: '6:39',
        },
        {
          title: 'Extra Details',
          duration: '7:02',
        },
        {
          title: 'Adding the Mess + Finishing Touches',
          duration: '6:56',
        },
      ],
    },
    {
      title: 'Project 7: Messy Beta Fish',
      videos: [
        {
          title: 'Setting up your File',
          duration: '9:04',
        },
        {
          title: 'Base Painting the Body',
          duration: '7:39',
        },
        {
          title: 'Base Painting the Head',
          duration: '9:33',
        },
        {
          title: 'Painting a Realistic Eye + Mouth',
          duration: '6:21',
        },
        {
          title: 'Painting the Fins: Part 1',
          duration: '9:00',
        },
        {
          title: 'Painting the Fins: Part 2',
          duration: '7:16',
        },
        {
          title: 'Painting the Fins: Part 3',
          duration: '9:59',
        },
        {
          title: 'Adding the Mess',
          duration: '9:34',
        },
        {
          title: 'Finishing Touches: Part 1',
          duration: '9:52',
        },
        {
          title: 'Finishing Touches: Part 2',
          duration: '3:09',
        },
      ],
    },
    {
      title: 'BONUS: Printing Your Pieces',
      videos: [
        {
          title: 'Printing Module Overview',
          duration: '2:13',
        },
        {
          title: 'At Home Printing: Test Prints Part 1',
          duration: '9:46',
        },
        {
          title: 'At Home Printing: Test Prints Part 2 + Final Print',
          duration: '11:30',
        },
        {
          title: 'Quick Tip: Non-Destructive Color Adjustments on Home Test Prints',
          duration: '4:22',
        },
        {
          title: 'Uploading + Printing with Shutterfly',
          duration: '5:40',
        },
        {
          title: 'Uploading + Printing with VistaPrint',
          duration: '5:41',
        },
        {
          title: 'Uploading + Printing with Uprinting',
          duration: '3:07',
        },
        {
          title: 'Uploading + Printing with Giclée Today',
          duration: '3:02',
        },
        {
          title: 'Uploading + Printing with Finer Works',
          duration: '1:57',
        },
        {
          title: 'Printed Artwork Examples + My Experiences',
          duration: '14:48',
        },
      ],
    },
    {
      title: 'Finishing Up',
      videos: [
        {
          title: 'Thank You + Next Steps',
          duration: '2:32',
        },
      ],
    },
  ],
  bonuses: {
    headerImgName: `procreate301/bonus-title.png`,
    imgAlt: 'Messy Watercolors in Procreate Bonuses',
    gridType: 2,
    items: [
      {
        title: 'Messy Watercolors Brush Set',
        desc: '<p>The full Procreate master brush set <span class="bold bonusPriceSpan">(200 brushes!)</span> are included with enrollment so you can follow along exactly. Brushes are separated into 8 categorized brush sets with painting, paper texture and stamp brushes all included.</p>',
        imgName: 'procreate601/brush-set-preview.jpg',
      },
      {
        title: 'Extended License of Messy Watercolors Brushes',
        desc: '<p>An extended license of the brush set <span class="bold bonusPriceSpan">($40 value)</span> is included, so you can create unlimited artwork now and in the future with full permissions to sell it.</p>',
        imgName: 'procreate601/bonus-2.jpg',
      },
      {
        title: 'Printing from Procreate Module',
        desc: '<p>Learn best practices for printing your Procreate artwork at home *and* using an online print service. We’ll go over adjusting colors, uploading our files, reviewing drafts, and I share my own artwork I’ve had printed along with my experiences.</p>',
        imgName: 'procreate601/bonus-3.jpg',
      },
      {
        title: 'Facebook Group',
        desc: '<p>Your enrollment includes access to our private Procreate Facebook group; a supportive community of digital creatives where you can share your progress, ask questions and receive feedback on your work.</p>',
        imgName: 'procreate601/bonus-4.jpg',
      },
    ],
  },
  courseCard: {
    title: 'Messy Watercolors in Procreate',
    backgroundImgName: ``,
    backgroundColor: '#65807c',
    cardImgName: `procreate301/watercolor-class-card-4.jpg`,
    desc: 'Paint vibrant and messy eye candy watercolor artwork in Procreate! Reference traditional methods while utilizing digital advantages like blend modes, selective color adjustments and layers. Follow along as each project builds in complexity with technique, process and levels of messiness. In addition to painting, you’ll learn and use multiple layers, blend modes, selections, recoloring, saturation adjustments and warping to create stunning artwork using an efficient process. Finish the course by learning how to prepare your artwork for print using a home printer or online print services to enjoy your art beyond the screen.',
    bullets: [
      'Access to 33 HD step-by-step videos',
      'Messy Watercolor Master Brush Set (208 brushes)',
      'Brush Set Extended License ($40 value)',
      'Bonus Procreate to Print module',
      'Tutorials for painting in the 3 messy levels',
      'Messy watercolor painting replication',
      'Realism and loose painting styles',
      'Unlimited updates',
      'Lifetime access to the class',
    ],
    brush: {
      enabled: true,
      image: {
        pencil: `apple2-pencil.png`,
        shadow: `sell-card-pencil-reflection-light.png`,
      },
    },
    priceColor: mainColor,
    saleColor: neonPink,
    stats: {
      modules: `#cc836f`,
      videos: `#758384`,
      hours: `#a79e8d`,
    },
  },
  faqs: [
    {
      question: 'Do you offer any refunds or guarantees?',
      answer: '<p>Yep! If you finish the course and feel you haven’t learned anything new, email me within 14 days of purchase for a full refund.</p>',
    },
    {
      question: 'How long can I access the course for?',
      answer: '<p>Forever! As long as Every Tuesday exists, this course will be available to watch. Take it at whatever pace you’d like, watch whenever, wherever and as many times as you’d like.</p>',
    },
    {
      question: 'Is this a live or pre-recorded course?',
      answer: '<p>This course is entirely pre-recorded, so you can take it whenever it works best with your schedule.</p>',
    },
    {
      question: 'Does this class come with subtitles/closed captions?',
      answer: '<p>Yes! There are English subtitles available for all videos.</p>',
    },
    {
      question: 'What will I need to take this class?',
      answer: '<p>You’ll need the Procreate app (v. 5.2.5 or newer), a pressure sensitive iPad (see this list: <a class="bold" style="color: #4D286F" target="_blank" href="https://every-tuesday.com/ipads">every-tuesday.com/ipads</a>), a stylus compatible with that iPad (I recommend an Apple Pencil) and a familiarity with Procreate (my free <a class="bold" style="color: #4D286F" target="_blank" href="https://every-tuesday.com/5x">Procreate for Beginners course</a> is recommended as a prerequisite.</p>',
    },
    {
      question: 'Do I need any special Procreate brushes to create these projects?',
      answer: '<p>Yes, and they’re all included for free with your enrollment. Refer to the course video titled ‘bonuses and install instructions’ for their location and a full installation tutorial.</p>',
    },
    {
      question: 'I noticed there’s a similar course offered on Skillshare. What’s the difference?',
      answer: '<p>The course on Skillshare is an intro version that only includes 2 projects from this class. For a full comparison of the two versions, please view <a style="color: #4D286F" class="bold" target="_blank" href="https://every-tuesday.com/messy-comparison">this chart</a>.</p>',
    },
    {
      question: 'I’m still learning Procreate. Is this for me?',
      answer: '<p>Yep! The course was designed with beginners in mind and it increases in complexity as the course progresses. You’ll want to be familiar with the interface before you begin, though, so my free <a style="color: #4D286F" class="bold" target="_blank" href="https://every-tuesday.com/5x">Procreate for Beginners</a> is recommended as a prerequisite.</p>',
    },
    {
      question: 'I have no experience with traditional watercolors. Can I still take this class?',
      answer: '<p>Yep! I show you everything you’ll need to know to replicate the style digitally and offer resources to guide you if you ever get stuck along the way.</p>',
    },
    {
      question: 'If I recreate these projects following your instruction, can I sell that artwork afterward?',
      answer: '<p>You may use any of the brushes and techniques provided in the class to create your own unique artwork to sell. You may not sell recreated class projects, as they are my own original artwork + concepts.</p>',
    },
  ],
  testimonials: [],
  letsDoThis: {
    imgName: 'procreate301/lets-do-this-2.jpg',
    altTag: 'Enroll in Messy Watercolors for Procreate today!',
    text: 'Welcome to Messy Watercolors in Procreate, your complete guide to delicious eye candy digital paintings.',
  },
  sellCard: {
    priceColor: mainColor,
    saleColor: neonPink,
    cardImg: '',
    saleLink: 'https://courses.every-tuesday.com/purchase?product_id=3961338',
    link: 'https://courses.every-tuesday.com/purchase?product_id=3961339',
    paymentPlanLink: 'https://courses.every-tuesday.com/purchase?product_id=3961340',
    customBtnBackgroundColor: mainColor,
    h2Color: mainColor,
    hoverColor: {
      h2: `#fff`,
      text: mainColor,
      overlay: `#3c2842`,
      cardDescription: '#fff'
    },
    bullets: [
      'Instant access to all videos and bonuses',
      'Full brush set of 200+ Messy Watercolor brushes',
      'Private Facebook Group',
      'Extended license of the brush set',
      'Bonus printing module',
      'Tutorials for painting in the 3 messy levels',
      'Messy watercolor painting replication',
      'Realism and loose painting styles',
      '14 day money back guarantee',
    ],
  },
}
export const gqlFragment601BrushTips = graphql`
    fragment Fragment601BrushTips on Query {
        splatterBrush1:imgixImage(url: "procreate601/brushes/messy-splatters/Splatter-01.jpg") {
            ...FragmentImgix500
        }
        splatterBrush2:imgixImage(url: "procreate601/brushes/messy-splatters/Splatter-02.jpg") {
            ...FragmentImgix500
        }
        splatterBrush3:imgixImage(url: "procreate601/brushes/messy-splatters/Splatter-03.jpg") {
            ...FragmentImgix500
        }
        splatterBrush4:imgixImage(url: "procreate601/brushes/messy-splatters/Splatter-04.jpg") {
            ...FragmentImgix500
        }
        splatterBrush5:imgixImage(url: "procreate601/brushes/messy-splatters/Splatter-05.jpg") {
            ...FragmentImgix500
        }
        splatterBrush6:imgixImage(url: "procreate601/brushes/messy-splatters/Splatter-06.jpg") {
            ...FragmentImgix500
        }
        splatterBrush7:imgixImage(url: "procreate601/brushes/messy-splatters/Splatter-07.jpg") {
            ...FragmentImgix500
        }
        splatterBrush8:imgixImage(url: "procreate601/brushes/messy-splatters/Splatter-08.jpg") {
            ...FragmentImgix500
        }
        splatterBrush9:imgixImage(url: "procreate601/brushes/messy-splatters/Splatter-09.jpg") {
            ...FragmentImgix500
        }
        splatterBrush10:imgixImage(url: "procreate601/brushes/messy-splatters/Splatter-10.jpg") {
            ...FragmentImgix500
        }
        splatterBrush11:imgixImage(url: "procreate601/brushes/messy-splatters/Splatter-11.jpg") {
            ...FragmentImgix500
        }
        splatterBrush12:imgixImage(url: "procreate601/brushes/messy-splatters/Splatter-12.jpg") {
            ...FragmentImgix500
        }
        splatterBrush13:imgixImage(url: "procreate601/brushes/messy-splatters/Splatter-13.jpg") {
            ...FragmentImgix500
        }
        splatterBrush14:imgixImage(url: "procreate601/brushes/messy-splatters/Splatter-14.jpg") {
            ...FragmentImgix500
        }
        splatterBrush15:imgixImage(url: "procreate601/brushes/messy-splatters/Splatter-15.jpg") {
            ...FragmentImgix500
        }
        splatterBrush16:imgixImage(url: "procreate601/brushes/messy-splatters/Splatter-16.jpg") {
            ...FragmentImgix500
        }
        splatterBrush17:imgixImage(url: "procreate601/brushes/messy-splatters/Splatter-17.jpg") {
            ...FragmentImgix500
        }
        splatterBrush18:imgixImage(url: "procreate601/brushes/messy-splatters/Splatter-18.jpg") {
            ...FragmentImgix500
        }
        splatterBrush19:imgixImage(url: "procreate601/brushes/messy-splatters/Splatter-19.jpg") {
            ...FragmentImgix500
        }

        bloomBrush1:imgixImage(url: "procreate601/brushes/messy-blooms/Bloom-01.jpg") {
            ...FragmentImgix500
        }
        bloomBrush2:imgixImage(url: "procreate601/brushes/messy-blooms/Bloom-02.jpg") {
            ...FragmentImgix500
        }
        bloomBrush3:imgixImage(url: "procreate601/brushes/messy-blooms/Bloom-03.jpg") {
            ...FragmentImgix500
        }
        bloomBrush4:imgixImage(url: "procreate601/brushes/messy-blooms/Bloom-04.jpg") {
            ...FragmentImgix500
        }
        bloomBrush5:imgixImage(url: "procreate601/brushes/messy-blooms/Bloom-05.jpg") {
            ...FragmentImgix500
        }
        bloomBrush6:imgixImage(url: "procreate601/brushes/messy-blooms/Bloom-06.jpg") {
            ...FragmentImgix500
        }
        bloomBrush7:imgixImage(url: "procreate601/brushes/messy-blooms/Bloom-07.jpg") {
            ...FragmentImgix500
        }
        bloomBrush8:imgixImage(url: "procreate601/brushes/messy-blooms/Bloom-08.jpg") {
            ...FragmentImgix500
        }
        bloomBrush9:imgixImage(url: "procreate601/brushes/messy-blooms/Bloom-09.jpg") {
            ...FragmentImgix500
        }
        bloomBrush10:imgixImage(url: "procreate601/brushes/messy-blooms/Bloom-10.jpg") {
            ...FragmentImgix500
        }
        bloomBrush11:imgixImage(url: "procreate601/brushes/messy-blooms/Bloom-11.jpg") {
            ...FragmentImgix500
        }
        bloomBrush12:imgixImage(url: "procreate601/brushes/messy-blooms/Bloom-12.jpg") {
            ...FragmentImgix500
        }
        bloomBrush13:imgixImage(url: "procreate601/brushes/messy-blooms/Bloom-13.jpg") {
            ...FragmentImgix500
        }
        bloomBrush14:imgixImage(url: "procreate601/brushes/messy-blooms/Bloom-14.jpg") {
            ...FragmentImgix500
        }
        bloomBrush15:imgixImage(url: "procreate601/brushes/messy-blooms/Bloom-15.jpg") {
            ...FragmentImgix500
        }
        bloomBrush16:imgixImage(url: "procreate601/brushes/messy-blooms/Bloom-16.jpg") {
            ...FragmentImgix500
        }
        bloomBrush17:imgixImage(url: "procreate601/brushes/messy-blooms/Bloom-17.jpg") {
            ...FragmentImgix500
        }
        bloomBrush18:imgixImage(url: "procreate601/brushes/messy-blooms/Bloom-18.jpg") {
            ...FragmentImgix500
        }
        bloomBrush19:imgixImage(url: "procreate601/brushes/messy-blooms/Bloom-19.jpg") {
            ...FragmentImgix500
        }        
        bloomBrush20:imgixImage(url: "procreate601/brushes/messy-blooms/Bloom-20.jpg") {
            ...FragmentImgix500
        }
        bloomBrush21:imgixImage(url: "procreate601/brushes/messy-blooms/Bloom-21.jpg") {
            ...FragmentImgix500
        }
        bloomBrush22:imgixImage(url: "procreate601/brushes/messy-blooms/Bloom-22.jpg") {
            ...FragmentImgix500
        }
        bloomBrush23:imgixImage(url: "procreate601/brushes/messy-blooms/Bloom-23.jpg") {
            ...FragmentImgix500
        }
        bloomBrush24:imgixImage(url: "procreate601/brushes/messy-blooms/Bloom-24.jpg") {
            ...FragmentImgix500
        }
        bloomBrush25:imgixImage(url: "procreate601/brushes/messy-blooms/Bloom-25.jpg") {
            ...FragmentImgix500
        }
        bloomBrush26:imgixImage(url: "procreate601/brushes/messy-blooms/Bloom-26.jpg") {
            ...FragmentImgix500
        }
        bloomBrush27:imgixImage(url: "procreate601/brushes/messy-blooms/Bloom-27.jpg") {
            ...FragmentImgix500
        }
        bloomBrush28:imgixImage(url: "procreate601/brushes/messy-blooms/Bloom-28.jpg") {
            ...FragmentImgix500
        }
        bloomBrush29:imgixImage(url: "procreate601/brushes/messy-blooms/Bloom-29.jpg") {
            ...FragmentImgix500
        }
        bloomBrush30:imgixImage(url: "procreate601/brushes/messy-blooms/Bloom-30.jpg") {
            ...FragmentImgix500
        }


        washBrush1:imgixImage(url: "procreate601/brushes/messy-washes/Wash-01.jpg") {
            ...FragmentImgix500
        }
        washBrush2:imgixImage(url: "procreate601/brushes/messy-washes/Wash-02.jpg") {
            ...FragmentImgix500
        }
        washBrush3:imgixImage(url: "procreate601/brushes/messy-washes/Wash-03.jpg") {
            ...FragmentImgix500
        }
        washBrush4:imgixImage(url: "procreate601/brushes/messy-washes/Wash-04.jpg") {
            ...FragmentImgix500
        }
        washBrush5:imgixImage(url: "procreate601/brushes/messy-washes/Wash-05.jpg") {
            ...FragmentImgix500
        }
        washBrush6:imgixImage(url: "procreate601/brushes/messy-washes/Wash-06.jpg") {
            ...FragmentImgix500
        }
        washBrush7:imgixImage(url: "procreate601/brushes/messy-washes/Wash-07.jpg") {
            ...FragmentImgix500
        }
        washBrush8:imgixImage(url: "procreate601/brushes/messy-washes/Wash-08.jpg") {
            ...FragmentImgix500
        }
        washBrush9:imgixImage(url: "procreate601/brushes/messy-washes/Wash-09.jpg") {
            ...FragmentImgix500
        }
        washBrush10:imgixImage(url: "procreate601/brushes/messy-washes/Wash-10.jpg") {
            ...FragmentImgix500
        }
        washBrush11:imgixImage(url: "procreate601/brushes/messy-washes/Wash-11.jpg") {
            ...FragmentImgix500
        }
        washBrush12:imgixImage(url: "procreate601/brushes/messy-washes/Wash-12.jpg") {
            ...FragmentImgix500
        }
        washBrush13:imgixImage(url: "procreate601/brushes/messy-washes/Wash-13.jpg") {
            ...FragmentImgix500
        }
        washBrush14:imgixImage(url: "procreate601/brushes/messy-washes/Wash-14.jpg") {
            ...FragmentImgix500
        }
        washBrush15:imgixImage(url: "procreate601/brushes/messy-washes/Wash-15.jpg") {
            ...FragmentImgix500
        }
        washBrush16:imgixImage(url: "procreate601/brushes/messy-washes/Wash-16.jpg") {
            ...FragmentImgix500
        }
        washBrush17:imgixImage(url: "procreate601/brushes/messy-washes/Wash-17.jpg") {
            ...FragmentImgix500
        }
        washBrush18:imgixImage(url: "procreate601/brushes/messy-washes/Wash-18.jpg") {
            ...FragmentImgix500
        }
        washBrush19:imgixImage(url: "procreate601/brushes/messy-washes/Wash-19.jpg") {
            ...FragmentImgix500
        }
        washBrush20:imgixImage(url: "procreate601/brushes/messy-washes/Wash-20.jpg") {
            ...FragmentImgix500
        }
        washBrush21:imgixImage(url: "procreate601/brushes/messy-washes/Wash-21.jpg") {
            ...FragmentImgix500
        }
        washBrush22:imgixImage(url: "procreate601/brushes/messy-washes/Wash-22.jpg") {
            ...FragmentImgix500
        }
        washBrush23:imgixImage(url: "procreate601/brushes/messy-washes/Wash-23.jpg") {
            ...FragmentImgix500
        }
        washBrush24:imgixImage(url: "procreate601/brushes/messy-washes/Wash-24.jpg") {
            ...FragmentImgix500
        }
        washBrush25:imgixImage(url: "procreate601/brushes/messy-washes/Wash-25.jpg") {
            ...FragmentImgix500
        }
        washBrush26:imgixImage(url: "procreate601/brushes/messy-washes/Wash-26.jpg") {
            ...FragmentImgix500
        }
        washBrush27:imgixImage(url: "procreate601/brushes/messy-washes/Wash-27.jpg") {
            ...FragmentImgix500
        }
        washBrush28:imgixImage(url: "procreate601/brushes/messy-washes/Wash-28.jpg") {
            ...FragmentImgix500
        }
        washBrush29:imgixImage(url: "procreate601/brushes/messy-washes/Wash-29.jpg") {
            ...FragmentImgix500
        }
        washBrush30:imgixImage(url: "procreate601/brushes/messy-washes/Wash-30.jpg") {
            ...FragmentImgix500
        }
        washBrush31:imgixImage(url: "procreate601/brushes/messy-washes/Wash-31.jpg") {
            ...FragmentImgix500
        }
        washBrush32:imgixImage(url: "procreate601/brushes/messy-washes/Wash-32.jpg") {
            ...FragmentImgix500
        }


        extraBrush1:imgixImage(url: "procreate601/brushes/messy-extras/extra-01.jpg") {
            ...FragmentImgix500
        }
        extraBrush2:imgixImage(url: "procreate601/brushes/messy-extras/extra-02.jpg") {
            ...FragmentImgix500
        }
        extraBrush3:imgixImage(url: "procreate601/brushes/messy-extras/extra-03.jpg") {
            ...FragmentImgix500
        }
        extraBrush4:imgixImage(url: "procreate601/brushes/messy-extras/extra-04.jpg") {
            ...FragmentImgix500
        }
        extraBrush5:imgixImage(url: "procreate601/brushes/messy-extras/extra-05.jpg") {
            ...FragmentImgix500
        }
        extraBrush6:imgixImage(url: "procreate601/brushes/messy-extras/extra-06.jpg") {
            ...FragmentImgix500
        }
        extraBrush7:imgixImage(url: "procreate601/brushes/messy-extras/extra-07.jpg") {
            ...FragmentImgix500
        }
        extraBrush8:imgixImage(url: "procreate601/brushes/messy-extras/extra-08.jpg") {
            ...FragmentImgix500
        }
        extraBrush9:imgixImage(url: "procreate601/brushes/messy-extras/extra-09.jpg") {
            ...FragmentImgix500
        }
        extraBrush10:imgixImage(url: "procreate601/brushes/messy-extras/extra-10.jpg") {
            ...FragmentImgix500
        }
        extraBrush11:imgixImage(url: "procreate601/brushes/messy-extras/extra-11.jpg") {
            ...FragmentImgix500
        }
        extraBrush12:imgixImage(url: "procreate601/brushes/messy-extras/extra-12.jpg") {
            ...FragmentImgix500
        }
        extraBrush13:imgixImage(url: "procreate601/brushes/messy-extras/extra-13.jpg") {
            ...FragmentImgix500
        }
        extraBrush14:imgixImage(url: "procreate601/brushes/messy-extras/extra-14.jpg") {
            ...FragmentImgix500
        }



        splashBrush1:imgixImage(url: "procreate601/brushes/messy-splashes/Splash-01.jpg") {
            ...FragmentImgix500
        }
        splashBrush2:imgixImage(url: "procreate601/brushes/messy-splashes/Splash-02.jpg") {
            ...FragmentImgix500
        }
        splashBrush3:imgixImage(url: "procreate601/brushes/messy-splashes/Splash-03.jpg") {
            ...FragmentImgix500
        }
        splashBrush4:imgixImage(url: "procreate601/brushes/messy-splashes/Splash-04.jpg") {
            ...FragmentImgix500
        }
        splashBrush5:imgixImage(url: "procreate601/brushes/messy-splashes/Splash-05.jpg") {
            ...FragmentImgix500
        }
        splashBrush6:imgixImage(url: "procreate601/brushes/messy-splashes/Splash-06.jpg") {
            ...FragmentImgix500
        }
        splashBrush7:imgixImage(url: "procreate601/brushes/messy-splashes/Splash-07.jpg") {
            ...FragmentImgix500
        }
        splashBrush8:imgixImage(url: "procreate601/brushes/messy-splashes/Splash-08.jpg") {
            ...FragmentImgix500
        }
        splashBrush9:imgixImage(url: "procreate601/brushes/messy-splashes/Splash-09.jpg") {
            ...FragmentImgix500
        }
        splashBrush10:imgixImage(url: "procreate601/brushes/messy-splashes/Splash-10.jpg") {
            ...FragmentImgix500
        }
        splashBrush11:imgixImage(url: "procreate601/brushes/messy-splashes/Splash-11.jpg") {
            ...FragmentImgix500
        }
        splashBrush12:imgixImage(url: "procreate601/brushes/messy-splashes/Splash-12.jpg") {
            ...FragmentImgix500
        }
        splashBrush13:imgixImage(url: "procreate601/brushes/messy-splashes/Splash-13.jpg") {
            ...FragmentImgix500
        }
        splashBrush14:imgixImage(url: "procreate601/brushes/messy-splashes/Splash-14.jpg") {
            ...FragmentImgix500
        }
        splashBrush15:imgixImage(url: "procreate601/brushes/messy-splashes/Splash-15.jpg") {
            ...FragmentImgix500
        }
        splashBrush16:imgixImage(url: "procreate601/brushes/messy-splashes/Splash-16.jpg") {
            ...FragmentImgix500
        }
        splashBrush17:imgixImage(url: "procreate601/brushes/messy-splashes/Splash-17.jpg") {
            ...FragmentImgix500
        }
        splashBrush18:imgixImage(url: "procreate601/brushes/messy-splashes/Splash-18.jpg") {
            ...FragmentImgix500
        }
        splashBrush19:imgixImage(url: "procreate601/brushes/messy-splashes/Splash-19.jpg") {
            ...FragmentImgix500
        }
        splashBrush20:imgixImage(url: "procreate601/brushes/messy-splashes/Splash-20.jpg") {
            ...FragmentImgix500
        }
        splashBrush21:imgixImage(url: "procreate601/brushes/messy-splashes/Splash-21.jpg") {
            ...FragmentImgix500
        }
        splashBrush22:imgixImage(url: "procreate601/brushes/messy-splashes/Splash-22.jpg") {
            ...FragmentImgix500
        }
        splashBrush23:imgixImage(url: "procreate601/brushes/messy-splashes/Splash-23.jpg") {
            ...FragmentImgix500
        }



        stainBrush1:imgixImage(url: "procreate601/brushes/messy-soft-stains/SoftStain-01.jpg") {
            ...FragmentImgix500
        }
        stainBrush2:imgixImage(url: "procreate601/brushes/messy-soft-stains/SoftStain-02.jpg") {
            ...FragmentImgix500
        }
        stainBrush3:imgixImage(url: "procreate601/brushes/messy-soft-stains/SoftStain-03.jpg") {
            ...FragmentImgix500
        }
        stainBrush4:imgixImage(url: "procreate601/brushes/messy-soft-stains/SoftStain-04.jpg") {
            ...FragmentImgix500
        }
        stainBrush5:imgixImage(url: "procreate601/brushes/messy-soft-stains/SoftStain-05.jpg") {
            ...FragmentImgix500
        }
        stainBrush6:imgixImage(url: "procreate601/brushes/messy-soft-stains/SoftStain-06.jpg") {
            ...FragmentImgix500
        }
        stainBrush7:imgixImage(url: "procreate601/brushes/messy-soft-stains/SoftStain-07.jpg") {
            ...FragmentImgix500
        }
        stainBrush8:imgixImage(url: "procreate601/brushes/messy-soft-stains/SoftStain-08.jpg") {
            ...FragmentImgix500
        }
        stainBrush9:imgixImage(url: "procreate601/brushes/messy-soft-stains/SoftStain-09.jpg") {
            ...FragmentImgix500
        }
        stainBrush10:imgixImage(url: "procreate601/brushes/messy-soft-stains/SoftStain-10.jpg") {
            ...FragmentImgix500
        }
        stainBrush11:imgixImage(url: "procreate601/brushes/messy-soft-stains/SoftStain-11.jpg") {
            ...FragmentImgix500
        }
        stainBrush12:imgixImage(url: "procreate601/brushes/messy-soft-stains/SoftStain-12.jpg") {
            ...FragmentImgix500
        }
        stainBrush13:imgixImage(url: "procreate601/brushes/messy-soft-stains/SoftStain-13.jpg") {
            ...FragmentImgix500
        }
        stainBrush14:imgixImage(url: "procreate601/brushes/messy-soft-stains/SoftStain-14.jpg") {
            ...FragmentImgix500
        }
        stainBrush15:imgixImage(url: "procreate601/brushes/messy-soft-stains/SoftStain-15.jpg") {
            ...FragmentImgix500
        }
        stainBrush16:imgixImage(url: "procreate601/brushes/messy-soft-stains/SoftStain-16.jpg") {
            ...FragmentImgix500
        }




        shapes01Brush1:imgixImage(url: "procreate601/brushes/messy-shapes-01/shape-1-1.jpg") {
            ...FragmentImgix500
        }
        shapes01Brush2:imgixImage(url: "procreate601/brushes/messy-shapes-01/shape-1-2.jpg") {
            ...FragmentImgix500
        }
        shapes01Brush3:imgixImage(url: "procreate601/brushes/messy-shapes-01/shape-1-3.jpg") {
            ...FragmentImgix500
        }
        shapes01Brush4:imgixImage(url: "procreate601/brushes/messy-shapes-01/shape-1-4.jpg") {
            ...FragmentImgix500
        }
        shapes01Brush5:imgixImage(url: "procreate601/brushes/messy-shapes-01/shape-1-5.jpg") {
            ...FragmentImgix500
        }
        shapes01Brush6:imgixImage(url: "procreate601/brushes/messy-shapes-01/shape-1-6.jpg") {
            ...FragmentImgix500
        }
        shapes01Brush7:imgixImage(url: "procreate601/brushes/messy-shapes-01/shape-1-7.jpg") {
            ...FragmentImgix500
        }
        shapes01Brush8:imgixImage(url: "procreate601/brushes/messy-shapes-01/shape-1-8.jpg") {
            ...FragmentImgix500
        }
        shapes01Brush9:imgixImage(url: "procreate601/brushes/messy-shapes-01/shape-1-9.jpg") {
            ...FragmentImgix500
        }
        shapes01Brush10:imgixImage(url: "procreate601/brushes/messy-shapes-01/shape-1-10.jpg") {
            ...FragmentImgix500
        }
        shapes01Brush11:imgixImage(url: "procreate601/brushes/messy-shapes-01/shape-1-11.jpg") {
            ...FragmentImgix500
        }
        shapes01Brush12:imgixImage(url: "procreate601/brushes/messy-shapes-01/shape-1-12.jpg") {
            ...FragmentImgix500
        }
        shapes01Brush13:imgixImage(url: "procreate601/brushes/messy-shapes-01/shape-1-13.jpg") {
            ...FragmentImgix500
        }
        shapes01Brush14:imgixImage(url: "procreate601/brushes/messy-shapes-01/shape-1-14.jpg") {
            ...FragmentImgix500
        }
        shapes01Brush15:imgixImage(url: "procreate601/brushes/messy-shapes-01/shape-1-15.jpg") {
            ...FragmentImgix500
        }
        shapes01Brush16:imgixImage(url: "procreate601/brushes/messy-shapes-01/shape-1-16.jpg") {
            ...FragmentImgix500
        }
        shapes01Brush17:imgixImage(url: "procreate601/brushes/messy-shapes-01/shape-1-17.jpg") {
            ...FragmentImgix500
        }
        shapes01Brush18:imgixImage(url: "procreate601/brushes/messy-shapes-01/shape-1-18.jpg") {
            ...FragmentImgix500
        }
        shapes01Brush19:imgixImage(url: "procreate601/brushes/messy-shapes-01/shape-1-19.jpg") {
            ...FragmentImgix500
        }
        shapes01Brush20:imgixImage(url: "procreate601/brushes/messy-shapes-01/shape-1-20.jpg") {
            ...FragmentImgix500
        }
        shapes01Brush21:imgixImage(url: "procreate601/brushes/messy-shapes-01/shape-1-21.jpg") {
            ...FragmentImgix500
        }
        shapes01Brush22:imgixImage(url: "procreate601/brushes/messy-shapes-01/shape-1-22.jpg") {
            ...FragmentImgix500
        }
        shapes01Brush23:imgixImage(url: "procreate601/brushes/messy-shapes-01/shape-1-23.jpg") {
            ...FragmentImgix500
        }
        shapes01Brush24:imgixImage(url: "procreate601/brushes/messy-shapes-01/shape-1-24.jpg") {
            ...FragmentImgix500
        }
        shapes01Brush25:imgixImage(url: "procreate601/brushes/messy-shapes-01/shape-1-25.jpg") {
            ...FragmentImgix500
        }
        shapes01Brush26:imgixImage(url: "procreate601/brushes/messy-shapes-01/shape-1-26.jpg") {
            ...FragmentImgix500
        }
        shapes01Brush27:imgixImage(url: "procreate601/brushes/messy-shapes-01/shape-1-27.jpg") {
            ...FragmentImgix500
        }
        shapes01Brush28:imgixImage(url: "procreate601/brushes/messy-shapes-01/shape-1-28.jpg") {
            ...FragmentImgix500
        }
        shapes01Brush29:imgixImage(url: "procreate601/brushes/messy-shapes-01/shape-1-29.jpg") {
            ...FragmentImgix500
        }
        shapes01Brush30:imgixImage(url: "procreate601/brushes/messy-shapes-01/shape-1-30.jpg") {
            ...FragmentImgix500
        }
        shapes01Brush31:imgixImage(url: "procreate601/brushes/messy-shapes-01/shape-1-31.jpg") {
            ...FragmentImgix500
        }
        shapes01Brush32:imgixImage(url: "procreate601/brushes/messy-shapes-01/shape-1-32.jpg") {
            ...FragmentImgix500
        }
        shapes01Brush33:imgixImage(url: "procreate601/brushes/messy-shapes-01/shape-1-33.jpg") {
            ...FragmentImgix500
        }
        shapes01Brush34:imgixImage(url: "procreate601/brushes/messy-shapes-01/shape-1-34.jpg") {
            ...FragmentImgix500
        }
        shapes01Brush35:imgixImage(url: "procreate601/brushes/messy-shapes-01/shape-1-35.jpg") {
            ...FragmentImgix500
        }
        shapes01Brush36:imgixImage(url: "procreate601/brushes/messy-shapes-01/shape-1-36.jpg") {
            ...FragmentImgix500
        }
        shapes01Brush37:imgixImage(url: "procreate601/brushes/messy-shapes-01/shape-1-37.jpg") {
            ...FragmentImgix500
        }
        shapes01Brush38:imgixImage(url: "procreate601/brushes/messy-shapes-01/shape-1-38.jpg") {
            ...FragmentImgix500
        }
        shapes01Brush39:imgixImage(url: "procreate601/brushes/messy-shapes-01/shape-1-39.jpg") {
            ...FragmentImgix500
        }
        shapes01Brush40:imgixImage(url: "procreate601/brushes/messy-shapes-01/shape-1-40.jpg") {
            ...FragmentImgix500
        }
        shapes01Brush41:imgixImage(url: "procreate601/brushes/messy-shapes-01/shape-1-41.jpg") {
            ...FragmentImgix500
        }
        shapes01Brush42:imgixImage(url: "procreate601/brushes/messy-shapes-01/shape-1-42.jpg") {
            ...FragmentImgix500
        }
        shapes01Brush43:imgixImage(url: "procreate601/brushes/messy-shapes-01/shape-1-43.jpg") {
            ...FragmentImgix500
        }
        shapes01Brush44:imgixImage(url: "procreate601/brushes/messy-shapes-01/shape-1-44.jpg") {
            ...FragmentImgix500
        }
        shapes01Brush45:imgixImage(url: "procreate601/brushes/messy-shapes-01/shape-1-45.jpg") {
            ...FragmentImgix500
        }
        shapes01Brush46:imgixImage(url: "procreate601/brushes/messy-shapes-01/shape-1-46.jpg") {
            ...FragmentImgix500
        }
        shapes01Brush47:imgixImage(url: "procreate601/brushes/messy-shapes-01/shape-1-47.jpg") {
            ...FragmentImgix500
        }
        shapes01Brush48:imgixImage(url: "procreate601/brushes/messy-shapes-01/shape-1-48.jpg") {
            ...FragmentImgix500
        }
        shapes01Brush49:imgixImage(url: "procreate601/brushes/messy-shapes-01/shape-1-49.jpg") {
            ...FragmentImgix500
        }
        shapes01Brush50:imgixImage(url: "procreate601/brushes/messy-shapes-01/shape-1-50.jpg") {
            ...FragmentImgix500
        }
        shapes01Brush51:imgixImage(url: "procreate601/brushes/messy-shapes-01/shape-1-51.jpg") {
            ...FragmentImgix500
        }
        shapes01Brush52:imgixImage(url: "procreate601/brushes/messy-shapes-01/shape-1-52.jpg") {
            ...FragmentImgix500
        }
        shapes01Brush53:imgixImage(url: "procreate601/brushes/messy-shapes-01/shape-1-53.jpg") {
            ...FragmentImgix500
        }

        shapes02Brush54:imgixImage(url: "procreate601/brushes/messy-shapes-02/shape-2-54.jpg") {
            ...FragmentImgix500
        }
        shapes02Brush55:imgixImage(url: "procreate601/brushes/messy-shapes-02/shape-2-55.jpg") {
            ...FragmentImgix500
        }
        shapes02Brush56:imgixImage(url: "procreate601/brushes/messy-shapes-02/shape-2-56.jpg") {
            ...FragmentImgix500
        }
        shapes02Brush57:imgixImage(url: "procreate601/brushes/messy-shapes-02/shape-2-57.jpg") {
            ...FragmentImgix500
        }
        shapes02Brush58:imgixImage(url: "procreate601/brushes/messy-shapes-02/shape-2-58.jpg") {
            ...FragmentImgix500
        }
        shapes02Brush59:imgixImage(url: "procreate601/brushes/messy-shapes-02/shape-2-59.jpg") {
            ...FragmentImgix500
        }
        shapes02Brush60:imgixImage(url: "procreate601/brushes/messy-shapes-02/shape-2-60.jpg") {
            ...FragmentImgix500
        }
        shapes02Brush61:imgixImage(url: "procreate601/brushes/messy-shapes-02/shape-2-61.jpg") {
            ...FragmentImgix500
        }
        shapes02Brush62:imgixImage(url: "procreate601/brushes/messy-shapes-02/shape-2-62.jpg") {
            ...FragmentImgix500
        }
        shapes02Brush63:imgixImage(url: "procreate601/brushes/messy-shapes-02/shape-2-63.jpg") {
            ...FragmentImgix500
        }
        shapes02Brush64:imgixImage(url: "procreate601/brushes/messy-shapes-02/shape-2-64.jpg") {
            ...FragmentImgix500
        }
        shapes02Brush65:imgixImage(url: "procreate601/brushes/messy-shapes-02/shape-2-65.jpg") {
            ...FragmentImgix500
        }
        shapes02Brush66:imgixImage(url: "procreate601/brushes/messy-shapes-02/shape-2-66.jpg") {
            ...FragmentImgix500
        }
        shapes02Brush67:imgixImage(url: "procreate601/brushes/messy-shapes-02/shape-2-67.jpg") {
            ...FragmentImgix500
        }
        shapes02Brush68:imgixImage(url: "procreate601/brushes/messy-shapes-02/shape-2-68.jpg") {
            ...FragmentImgix500
        }
        shapes02Brush69:imgixImage(url: "procreate601/brushes/messy-shapes-02/shape-2-69.jpg") {
            ...FragmentImgix500
        }
        shapes02Brush70:imgixImage(url: "procreate601/brushes/messy-shapes-02/shape-2-70.jpg") {
            ...FragmentImgix500
        }
        shapes02Brush71:imgixImage(url: "procreate601/brushes/messy-shapes-02/shape-2-71.jpg") {
            ...FragmentImgix500
        }
        shapes02Brush72:imgixImage(url: "procreate601/brushes/messy-shapes-02/shape-2-72.jpg") {
            ...FragmentImgix500
        }
        shapes02Brush73:imgixImage(url: "procreate601/brushes/messy-shapes-02/shape-2-73.jpg") {
            ...FragmentImgix500
        }
        shapes02Brush74:imgixImage(url: "procreate601/brushes/messy-shapes-02/shape-2-74.jpg") {
            ...FragmentImgix500
        }

    }
`
export const gqlFragmentProcreate601WYL = graphql`
    fragment FragmentProcreate601WYL on Query {
        wylGridImage1:imgixImage(url: "procreate601/wyl/wyl-item-1.jpg") {
            gatsbyImageData(layout:FULL_WIDTH, placeholder: BLURRED, imgixParams: {
                w: 500
            })
        }
        wylGridImage2:imgixImage(url: "procreate601/wyl/wyl-item-2.jpg") {
            gatsbyImageData(layout:FULL_WIDTH, placeholder: BLURRED, imgixParams: {
                w: 500
            })
        }
        wylGridImage3:imgixImage(url: "procreate601/wyl/wyl-item-3.jpg") {
            gatsbyImageData(layout:FULL_WIDTH, placeholder: BLURRED, imgixParams: {
                w: 500
            })
        }
        wylGridImage4:imgixImage(url: "procreate601/wyl/wyl-item-4.jpg") {
            gatsbyImageData(layout:FULL_WIDTH, placeholder: BLURRED, imgixParams: {
                w: 500
            })
        }
        wylGridImage5:imgixImage(url: "procreate601/wyl/wyl-item-5.jpg") {
            gatsbyImageData(layout:FULL_WIDTH, placeholder: BLURRED, imgixParams: {
                w: 500
            })
        }
        wylGridImage6:imgixImage(url: "procreate601/wyl/wyl-item-6.jpg") {
            gatsbyImageData(layout:FULL_WIDTH, placeholder: BLURRED, imgixParams: {
                w: 500
            })
        }
        wylGridImage7:imgixImage(url: "procreate601/wyl/wyl-item-7.jpg") {
            gatsbyImageData(layout:FULL_WIDTH, placeholder: BLURRED, imgixParams: {
                w: 500
            })
        }
        wylGridImage8:imgixImage(url: "procreate601/wyl/wyl-item-8.jpg") {
            gatsbyImageData(layout:FULL_WIDTH, placeholder: BLURRED, imgixParams: {
                w: 500
            })
        }
        wylGridImage9:imgixImage(url: "procreate601/wyl/wyl-item-9.jpg") {
            gatsbyImageData(layout:FULL_WIDTH, placeholder: BLURRED, imgixParams: {
                w: 500
            })
        }
        wylGridImage10:imgixImage(url: "procreate601/wyl/wyl-item-10.jpg") {
            gatsbyImageData(layout:FULL_WIDTH, placeholder: BLURRED, imgixParams: {
                w: 500
            })
        }
        wylGridImage11:imgixImage(url: "procreate601/wyl/wyl-item-11.jpg") {
            gatsbyImageData(layout:FULL_WIDTH, placeholder: BLURRED, imgixParams: {
                w: 500
            })
        }
        wylGridImage12:imgixImage(url: "procreate601/wyl/wyl-item-12.jpg") {
            gatsbyImageData(layout:FULL_WIDTH, placeholder: BLURRED, imgixParams: {
                w: 500
            })
        }
        wylSquareImage1:imgixImage(url: "procreate601/wyl-square-a.jpg") {
            gatsbyImageData(layout:FULL_WIDTH, placeholder: BLURRED,  imgixParams: {
                w: 400
            })
        }
        wylSquareImage2:imgixImage(url: "procreate601/wyl-square-b.jpg") {
            gatsbyImageData(layout:FULL_WIDTH, placeholder: BLURRED, imgixParams: {
                w: 800
            })
        }
    }
`
export const gqlFragmentProcreate601AdvItems = graphql`
    fragment FragmentProcreate601AdvItems on Query {
        advItem1:imgixImage(url: "procreate601/adv-1.jpg") {
            gatsbyImageData(layout:FULL_WIDTH, placeholder: BLURRED, imgixParams: {
                w: 500
            })
        }
        advItem2:imgixImage(url: "procreate601/adv-2.jpg") {
            gatsbyImageData(layout:FULL_WIDTH, placeholder: BLURRED, imgixParams: {
                w: 500
            })
        }
        advItem3:imgixImage(url: "procreate601/adv-3.jpg") {
            gatsbyImageData(layout:FULL_WIDTH, placeholder: BLURRED, imgixParams: {
                w: 500
            })
        }
        advItem4:imgixImage(url: "procreate601/adv-4.jpg") {
            gatsbyImageData(layout:FULL_WIDTH, placeholder: BLURRED, imgixParams: {
                w: 500
            })
        }
        advItem5:imgixImage(url: "procreate601/adv-5.jpg") {
            gatsbyImageData(layout:FULL_WIDTH, placeholder: BLURRED, imgixParams: {
                w: 500
            })
        }
        advItem6:imgixImage(url: "procreate601/adv-6.jpg") {
            gatsbyImageData(layout:FULL_WIDTH, placeholder: BLURRED, imgixParams: {
                w: 500
            })
        }
    }
`
export const gqlFragmentProcreate601StaggerGrid = graphql`
    fragment FragmentProcreate601StaggerGrid on Query {
        staggerGridItem1:imgixImage(url: "procreate601/stagger-type-1.jpg") {
            gatsbyImageData(layout:FULL_WIDTH, placeholder: BLURRED, imgixParams: {
                w: 500,
                auto: "compress"
            })
        }
        staggerGridItem3:imgixImage(url: "procreate601/stagger-type-2-min.png") {
            gatsbyImageData(layout:FULL_WIDTH, placeholder: BLURRED, imgixParams: {
                w: 500,
                auto: "compress"
            })
        }
        staggerGridItem2:imgixImage(url: "procreate601/stagger-type-3.jpg") {
            gatsbyImageData(layout:FULL_WIDTH, placeholder: BLURRED, imgixParams: {
                w: 500,
                auto: "compress"
            })
        }
        staggerGridItem4:imgixImage(url: "procreate401/staggered-grid/soft-edge-min.png") {
            gatsbyImageData(layout:FULL_WIDTH, placeholder: BLURRED, imgixParams: {
                w: 500,
                auto: "compress"
            })
        }
    }
`
export default course
